import useSWR from 'swr';

import { verifyScopes } from "../firebase/functions";

export const useVerifyScopes = (shop: string) => {
  const { data, error, mutate } = useSWR(`/verify-scopes/${shop}`, () => verifyScopes({
    shop,
  }));

  return {
    data,
    isLoading: !error && !data,
    error,
    mutate
  };
};
